"use client";

import type { ControllerRenderProps } from "react-hook-form";
import { removeCountryQueryParam } from "@/lib/client/browserCountry";
import { useCountryStore } from "@/lib/client/stores/useCountryStore";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui";

class FieldValues {}

export const CountrySelector = <T extends FieldValues>({
  field,
}: {
  field?: ControllerRenderProps<T>;
}) => {
  const { countries, country, setCountry } = useCountryStore();

  // Use field value if available, otherwise fall back to store value
  const selectValue = field?.value ?? country.countryCode ?? "";

  return (
    <Select
      value={selectValue}
      onValueChange={(value: string) => {
        field?.onChange(value);
        setCountry(value);

        // A feed URL is an entry hint, not a permanent shipping preference.
        const url = new URL(window.location.href);
        if (url.searchParams.has("country")) {
          window.history.replaceState(window.history.state, "", removeCountryQueryParam(url));
        }
      }}
    >
      <SelectTrigger className="flex-1">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {countries?.map((country) => (
          <SelectItem
            key={country.countryCode}
            value={country.countryCode}
          >
            {country.country} - {country.symbol}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
